import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'scaleText'
})
export class ScaleTextPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    console.log(value)
    console.log(args)
    return value;
  }

}



// WEBPACK FOOTER //
// ./public/app/_pipes/scale-text.pipe.ts